import { toast } from '@/view/components/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Banner, BannerType } from '../entities/Banner'
import { bannerService } from '../services/bannerService'

export const useBannersMutations = (type: BannerType) => {
  const queryClient = useQueryClient()

  const updateMutation = useMutation({
    mutationFn: (banners: Banner[]) =>
      bannerService.updateBanners(type, banners),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['banners', type] })
      toast({
        title: 'Banners atualizados com sucesso!',
      })
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro ao atualizar banners. Tente novamente mais tarde.',
      })
    },
  })

  const uploadImageMutation = useMutation({
    mutationFn: (file: File) => bannerService.uploadBanner(type, file, {}),
  })

  const uploadMutation = useMutation({
    mutationFn: ({ file, ...input }: { file: File; link: string }) => {
      return bannerService.uploadBanner(type, file, input)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['banners', type] })
      toast({
        title: 'Banner enviado com sucesso!',
      })
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro ao enviar banner. Tente novamente mais tarde.',
      })
    },
  })

  return {
    updateBanners: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    createBanner: uploadMutation.mutateAsync,
    uploadBannerImage: uploadImageMutation.mutateAsync,
    isUploading: uploadMutation.isPending,
    isUploadingImage: uploadImageMutation.isPending,
  }
}
